export const FORM_SETTINGS_ACTIVE_ICONS: {
  distanceSearch: string;
} = {
  distanceSearch: 'straighten'
};

export const FORM_SETTINGS_INACTIVE_ICONS: {
  distanceSearch: string;
} = {
  distanceSearch: 'straighten'
};
